import changeCart from '../../lib/changeCart';
import { SWATCHES } from '../../utils/constants';

const CART_LINE_ITEM_SELECTOR = '[data-cart-line-item]';

const fetchCartSwatchData = async () => {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
  if (!response.ok) return null;
  const cart = await response.json();
  const swatchItems = cart.items.filter((item) => item.properties?.[SWATCHES.PROPERTY_KEY] === 'true');
  const totalSwatches = swatchItems.reduce((sum, item) => sum + item.quantity, 0);
  return { swatchItems, totalSwatches };
};

const updateCartSwatchIncrementState = async () => {
  try {
    const data = await fetchCartSwatchData();
    if (!data) return;
    const atLimit = data.totalSwatches >= SWATCHES.MAX_QUANTITY;
    data.swatchItems.forEach((item) => {
      const lineEl = document.querySelector(`[data-test-id="cart-item-${item.key}"]`);
      const incrementBtn = lineEl?.querySelector('[data-cart-qty-button="increment"]');
      if (incrementBtn) incrementBtn.disabled = atLimit;
    });
  } catch (error) {
    console.warn('Could not update swatch increment state:', error);
  }
};

const initCartPage = () => {
  updateCartSwatchIncrementState();

  const quantityInputs = document.querySelectorAll('[data-cart-qty]');

  const updateLineItem = async (input, newQty) => {
    const lineItemKey = input.dataset.cartQty;
    const line = input.closest(CART_LINE_ITEM_SELECTOR);
    if (line) {
      line.classList.add('opacity-50');
    }
    input.disabled = true;
    await changeCart(lineItemKey, newQty);
    window.location.reload();
  };

  quantityInputs.forEach((input) => {
    input.addEventListener('change', async () => {
      const lineItemKey = input.dataset.cartQty;
      try {
        const data = await fetchCartSwatchData();
        if (data) {
          const thisItem = data.swatchItems.find((item) => item.key === lineItemKey);
          if (thisItem) {
            const otherQty = data.totalSwatches - thisItem.quantity;
            input.value = String(Math.min(+input.value, Math.max(1, SWATCHES.MAX_QUANTITY - otherQty)));
          }
        }
      } catch (error) {
        console.warn('Could not verify swatch limit before change:', error);
      }
      await updateLineItem(input, +input.value);
    });
  });

  document.addEventListener('click', async (evt) => {
    const qtyBtn = evt.target.closest('[data-cart-qty-button]');
    if (!qtyBtn) return;

    const line = qtyBtn.closest(CART_LINE_ITEM_SELECTOR);
    const input = line?.querySelector('[data-cart-qty]');
    if (!input) return;

    if (qtyBtn.dataset.cartQtyButton === 'increment') {
      try {
        const data = await fetchCartSwatchData();
        if (data) {
          const isSwatchItem = data.swatchItems.some((item) => item.key === input.dataset.cartQty);
          if (isSwatchItem && data.totalSwatches >= SWATCHES.MAX_QUANTITY) return;
        }
      } catch (error) {
        console.warn('Could not verify swatch limit before increment:', error);
      }
    }

    const currentValue = Number(input.value) || 1;
    const newQty = qtyBtn.dataset.cartQtyButton === 'increment'
      ? currentValue + 1
      : Math.max(1, currentValue - 1);

    if (newQty === currentValue) return;

    qtyBtn.disabled = true;
    input.value = String(newQty);
    await updateLineItem(input, newQty);
  });
};

export default initCartPage;
